var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 29.5,
    height: 29.5,
    rx: 14.75,
    fill: "#F2FCF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 29.5,
    height: 29.5,
    rx: 14.75,
    stroke: "#01C37D",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9648 22.9648H8.96484C7.86026 22.9648 6.96484 22.0694 6.96484 20.9648L6.96492 8.96483C6.96493 7.86027 7.86036 6.96484 8.96492 6.96484H17.9651C19.0697 6.96484 19.9651 7.86027 19.9651 8.96484V12.9648M10.4652 10.9648H16.4652M10.4652 13.9648H16.4652M10.4652 16.9648H13.4652M15.965 20.2074L20.2076 15.9647L23.0361 18.7932L18.7934 23.0358H15.965V20.2074Z",
    stroke: "#01C37D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone1);
export default __webpack_public_path__ + "static/media/megaphone (1).ca5a24b784b260bc9dc35a30502142fd.svg";
export { ForwardRef as ReactComponent };